module.exports = __webpack_public_path__ + "img/australia-colorectal-cancer-male.72f11dd4.png";